import * as _ from 'lodash';
import * as contentDefaults from './constants/contentDefaults';
import { normalizeMedia } from './services/contentNormalizer';
import { MediaItemTypes } from './types/content';
export function getMediaValue(itemValues, contentIndex, locale, geo, forceAllTypes, mediaTypesToIgnore) {
    if (forceAllTypes === void 0) { forceAllTypes = false; }
    if (mediaTypesToIgnore === void 0) { mediaTypesToIgnore = []; }
    var bgVideos = getMediaContent(itemValues, contentIndex, MediaItemTypes.Video, locale, geo);
    var images = getMediaContent(itemValues, contentIndex, MediaItemTypes.Image, locale, geo);
    var shapes = getMediaContent(itemValues, contentIndex, MediaItemTypes.Shape, locale, geo);
    var cliparts = getMediaContent(itemValues, contentIndex, MediaItemTypes.Clipart, locale, geo);
    var extVideos = getMediaContent(itemValues, contentIndex, MediaItemTypes.ExtVideo, locale, geo);
    bgVideos = fillDefaultValue(bgVideos, 'bgVideo', forceAllTypes);
    images = fillDefaultValue(images, 'images', forceAllTypes);
    shapes = fillDefaultValue(shapes, 'shape', forceAllTypes);
    cliparts = fillDefaultValue(cliparts, 'clipart', forceAllTypes);
    extVideos = fillDefaultValue(extVideos, 'extVideo', forceAllTypes);
    return images
        .concat(shapes)
        .concat(cliparts)
        .concat(bgVideos)
        .concat(extVideos)
        .filter(function (mediaItem) { return !_.includes(mediaTypesToIgnore, mediaItem.mediaType); })
        .map(function (mediaItem) { return normalizeMedia(mediaItem); });
}
function fillDefaultValue(values, type, forceAllTypes) {
    var newValues = null;
    var localContentDefaults = contentDefaults;
    if (!values || (values.length === 0 && forceAllTypes)) {
        newValues = [].concat(localContentDefaults[type]);
    }
    return newValues || values;
}
function getMediaContent(itemValues, index, mediaType, locale, geo) {
    // create a list of all relevant media items
    var relevantMediaByScore = {};
    var maxMediaScore = 0;
    _.filter(itemValues, function (item) { return item.score; }).forEach(function (item) {
        var mediaItems = _.filter(item.content, function (mediaItem) { return mediaItem.mediaType === mediaType; });
        if (mediaItems.length > 0) {
            var mediaByScore = relevantMediaByScore[item.score] || [];
            if (item.score > maxMediaScore) {
                maxMediaScore = item.score;
            }
            relevantMediaByScore[item.score] = mediaByScore.concat(mediaItems);
        }
    });
    if (maxMediaScore === 0) {
        return [];
    }
    var mediaList = geo
        ? filterMediaByGeo(relevantMediaByScore[maxMediaScore], geo)
        : filterMediaByLocale(relevantMediaByScore[maxMediaScore], locale);
    return _.range(0, mediaList.length).map(function (i) {
        var normalizedIndex = cycleIndex(Number(index) + Number(i), mediaList.length);
        return mediaList[normalizedIndex];
    });
}
function filterMediaByLocale(mediaList, locale) {
    var newMediaList = mediaList;
    var hasAnyImageInTheCurrentLocale = newMediaList.some(function (mediaItem) {
        return (mediaItem.mediaType === MediaItemTypes.Image &&
            mediaItem.locales &&
            mediaItem.locales.includes(locale));
    });
    // if we have any image in the current locale we have to delete other images that are tagged as 'all'
    if (hasAnyImageInTheCurrentLocale) {
        newMediaList = newMediaList.filter(function (mediaItem) {
            // if media item doesn't have locales, do not remove it
            if (!mediaItem.locales) {
                return true;
            }
            // remove all images that is not in current locale
            if (mediaItem.mediaType === MediaItemTypes.Image) {
                return mediaItem.locales.includes(locale);
            }
            // keep video/shape/clipart/etc.. or images that are marked as 'all'
            return true;
        });
    }
    return newMediaList;
}
function filterMediaByGeo(mediaList, geo) {
    var newMediaList = mediaList;
    var hasAnyImageInTheCurrentGeo = newMediaList.some(function (mediaItem) {
        return (mediaItem.mediaType === MediaItemTypes.Image &&
            mediaItem.geo &&
            mediaItem.geo.includes(geo));
    });
    // if we have any image in the current geo we have to delete other images that are tagged as 'all'
    if (hasAnyImageInTheCurrentGeo) {
        newMediaList = newMediaList.filter(function (mediaItem) {
            // if media item doesn't have geo, do not remove it
            if (!mediaItem.geo) {
                return true;
            }
            // remove all images that is not in current geo
            if (mediaItem.mediaType === MediaItemTypes.Image) {
                return mediaItem.geo.includes(geo);
            }
            // keep video/shape/clipart/etc.. or images that are marked as 'all'
            return true;
        });
    }
    return newMediaList;
}
function cycleIndex(index, count) {
    return index % count;
}
//# sourceMappingURL=contentAllocator.js.map